// import React from "react";
// import { Field, ErrorMessage } from "formik";
// import { FormGroup, FormLabel, Row } from "react-bootstrap";

// const TextInput = ({ label, name, type = "text",placeholder, ...rest }) => {
//   return (
//     <>
//       <Row>
//         <FormGroup>
//           <FormLabel className="col-form-label text-dark" htmlFor={name}>
//             {/* {label}:<span className="text-danger">*</span> */}
//             {label}
//           </FormLabel>
//           <div className="">
//             {/*col-lg-6  */}
//             <Field className="form-control" id={name} name={name} type={type} placeholder={placeholder} {...rest}/>
//             <ErrorMessage name={name} component="div" className="error-message text-danger" />
//           </div>
//         </FormGroup>
//       </Row>
//     </>
//   );
// };

// export default TextInput;


// =================================================================================================

import React from "react";
import { Field, ErrorMessage } from "formik";
import { FormGroup, FormLabel, Row } from "react-bootstrap";

const TextInput = ({ label, name, type = "text", placeholder, ...rest }) => {
  return (
    <>
      <Row>
        <FormGroup controlId={name}>
          <FormLabel className="col-form-label text-dark fw-bold">
            {/* {label}:<span className="text-danger">*</span> */}
            {label}
          </FormLabel>
          <div className="">
            {/*col-lg-6  */}
            <Field className="form-control" id={name} name={name} type={type} placeholder={placeholder} {...rest} />
            <ErrorMessage name={name} component="div" className="error-message text-danger" />
          </div>
        </FormGroup>
      </Row>
    </>
  );
};

export default TextInput;
